import { SEOHead } from "@/components/SEOHead";
import { HeaderNavigation } from "@/components/HeaderNavigation";
import { FooterSEO } from "@/components/FooterSEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { PropertyCard } from "@/components/PropertyCard";
import { useListings } from "@/hooks/use-listings";
import { Map, Layers, Compass, TrendingUp } from "lucide-react";
import { Card } from "@/components/ui/card";

export default function LandListingsPage() {
  const { listings } = useListings();
  const landListings = listings.filter((p) => p.category === "arsa");

  return (
    <div className="min-h-screen bg-background flex flex-col justify-between">
      <SEOHead
        title="Adana Satılık Arsa & Yatırımlık Arazi | Corner Gayrimenkul"
        description="Adana Sarıçam, Çukurova ve Seyhan bölgelerinde konut imarlı satılık arsa, ticari arazi ve kat karşılığı arsa portföyleri."
        canonicalPath="/arsa"
      />
      <HeaderNavigation />

      <main className="flex-1 py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">
        <Breadcrumbs items={[{ label: "Arsa & Arazi" }]} />

        {/* Hero Section */}
        <div className="relative rounded-3xl overflow-hidden bg-slate-900 text-white p-8 sm:p-12 mb-12 shadow-2xl border border-slate-800">
          <div className="max-w-3xl space-y-4">
            <span className="px-3 py-1 rounded-full bg-emerald-500/20 text-emerald-400 border border-emerald-500/30 text-xs font-bold uppercase tracking-wider flex items-center gap-1.5 w-fit">
              <Map className="h-3.5 w-3.5" /> Adana Arazi & Arsa Piyasası
            </span>
            <h1 className="text-3xl sm:text-5xl font-black tracking-tight leading-tight">
              Adana Satılık Arsa & Arazi
            </h1>
            <p className="text-slate-300 text-lg leading-relaxed">
              Adana genelindeki yayınlanmış arsa ve arazi ilanlarını inceleyin. İmar, tapu ve parsel bilgilerini ilgili resmî kayıtlardan doğrulayın.
            </p>
          </div>
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <Card className="p-6 bg-card border border-border">
            <Layers className="h-8 w-8 text-emerald-600 mb-3" />
            <h3 className="font-bold text-lg text-foreground mb-1">Konut İmarlı Arsalar</h3>
            <p className="text-sm text-muted-foreground">Müstakil villa yapımına veya emsal inşaat ruhsatına uygun parseller.</p>
          </Card>

          <Card className="p-6 bg-card border border-border">
            <Compass className="h-8 w-8 text-emerald-600 mb-3" />
            <h3 className="font-bold text-lg text-foreground mb-1">Gelişme Aksındaki Bölgeler</h3>
            <p className="text-sm text-muted-foreground">Sarıçam ve Çukurova'da yeni bulvar ve çevre yolu bağlantılı araziler.</p>
          </Card>

          <Card className="p-6 bg-card border border-border">
            <TrendingUp className="h-8 w-8 text-emerald-600 mb-3" />
            <h3 className="font-bold text-lg text-foreground mb-1">Kat Karşılığı & Yatırım</h3>
            <p className="text-sm text-muted-foreground">Kat karşılığı seçenekleri ve arazi özellikleri için danışmanlık alın.</p>
          </Card>
        </div>

        {/* Listings Grid */}
        <section className="mb-12">
          <h2 className="text-2xl font-extrabold text-foreground mb-6">
            Aktif Arsa & Arazi İlanları
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {landListings.map((prop) => (
              <PropertyCard key={prop.id} property={prop} />
            ))}
          </div>
        </section>
      </main>

      <FooterSEO />
    </div>
  );
}
